import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { CarouselComponent } from 'ngx-owl-carousel-o';
import { CategoryService } from 'src/app/services/category.service';
import { CommonService } from 'src/app/services/common.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-home-banner-layout2',
  templateUrl: './home-banner-layout2.component.html',
  styleUrls: ['./home-banner-layout2.component.scss']
})
export class HomeBannerLayout2Component {

  public serverPath = environment.commonImageApi + '/commonSlider/';

  @Input() item: any;
  
  @Input() brands: any[] = [];

  width:any;
  height:any;
  gapBetweenImage:any;
  customField12:any;
  customField11:any;
  type:any=0;

  public LogoSliderConfig: any;
  
  constructor(  private commonService: CommonService,
    private categoryService: CategoryService) { }

    LogoSlider = {
      ...sliderOpt,
      nav: false,
      dots: false,
      items: 3,
      margin: 20,
      loop: false,
      autoHeight: true,
      autoplay: true,
      
      responsive: {
          767: {
              items: 5
          },
          576: {
              items: 4
          },
          480: {
              items: 3
          },
          0: {
              items: 2
          }
      }
  }
  
  ngOnInit(): void {
    

    if ( this.item.gapBetweenImage.endsWith('px')) {
      this.item.gapBetweenImage= this.item.gapBetweenImage.slice(0, -2); 
    }
  
    
    this.LogoSlider.margin=this.item.gapBetweenImage;
    this.LogoSliderConfig=this.LogoSlider;
    
  }


  goToCategory(menu) {
    this.commonService.selectedCategory(menu.categoryName,menu.categoryId,menu);

  }

  
  imageNavigation(id){

    if(id>0){
      this.commonService.goToCategory(1, parseInt(id));
    }

  }

  catId:any;
 
  goToCategories(id: any) {
    if(id>0){
      this.commonService.goToCategory(1, parseInt(id));
    }

  }

  @ViewChild('owlCar') owlCarousel: CarouselComponent;

 
  

}
export const sliderOpt = {
  items: 1,
  loop: true,
  margin: 0,
  responsiveClass: true,
  nav: true,
  navText: [ '<i class="icon-angle-left">', '<i class="icon-angle-right">' ],
  dots: true,
  smartSpeed: 400,
  autoplay: false,
  autoplayTimeout: 15000
}

